import { getApiRequest } from 'api';
import { TUnreadNewsStatus } from 'api/services/news';

export const getUnreadNewsStatus = (): Promise<TUnreadNewsStatus> => {
    return getApiRequest(`/news/unread/exists/`);
};
